import { Container, Grid, Tab, Tabs } from '@material-ui/core';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ChainEditForm from './components/ChainEditForm';

const ChainEditPage = () => {
    const { chainId } = useParams();

    return (
        <Container fixed className="activity-edit page">
            <Grid className="pageWithSidebar">
                <Tabs orientation="vertical" variant="scrollable" value={0}>
                    <Tab label="Chain" component={Link} to={`/admin/chains/update/${chainId}/`} />
                    <Tab
                        label="Companies"
                        component={Link}
                        to={`/admin/chains/update/${chainId}/companies/`}
                    />
                    <Tab
                        label="Price items"
                        component={Link}
                        to={`/admin/chains/update/${chainId}/priceitems/`}
                    />
                </Tabs>
                <Grid className="pageContent">
                    <ChainEditForm chainId={chainId} />
                </Grid>
            </Grid>
        </Container>
    );
};

export default ChainEditPage;
